import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PropertyManagers from "@/pages/PropertyManagers";
import Faq from "@/pages/Faq";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DrywallPaint from "@/pages/DrywallPaint";
import SolarTubes from "@/pages/SolarTubes";
import Fans from "@/pages/Fans";
import Decks from "@/pages/Decks";
import BathroomRemodel from "@/pages/BathroomRemodel";
import MediaWalls from "@/pages/MediaWalls";
import RoofDemossing from "@/pages/RoofDemossing";
import ScrollToTop from "@/components/ScrollToTop";

// Extracted so we don't create a new object reference on every render of <App />.
const TOAST_OPTIONS = {
    style: {
        borderRadius: 0,
        border: "1px solid #111111",
        background: "#FFFFFF",
        color: "#111812",
        fontFamily: "Manrope, sans-serif",
    },
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/managers" element={<PropertyManagers />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/drywall-paint" element={<DrywallPaint />} />
                    <Route path="/solar-tubes" element={<SolarTubes />} />
                    <Route path="/fans" element={<Fans />} />
                    <Route path="/decks" element={<Decks />} />
                    <Route path="/bathroom-remodel" element={<BathroomRemodel />} />
                    <Route path="/media-walls" element={<MediaWalls />} />
                    <Route path="/roof-demossing" element={<RoofDemossing />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
        </div>
    );
}

export default App;
